<div class="modal-content" role="dialog" aria-modal="true">
  <div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <h2 mat-dialog-title>{{title}}</h2>
    <mat-icon>drag_indicator</mat-icon>
  </div>
  <div class="wait" [class]="{ 'waiting': saving }"><mat-spinner></mat-spinner></div>
  <mat-dialog-content class="dialog-container">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Notes</mat-label>
      <textarea matInput [formControl]="notesControl" rows="4" [readonly]="data.readonly"></textarea>
    </mat-form-field>
    @if (lastSaveMessage) {
    <div class="last-save-message">{{lastSaveMessage}}</div>
    }
  </mat-dialog-content>
  @if (! data.readonly) {
  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="onSave()" [disabled]="notesControl.invalid">Save</button>
    <button mat-button (click)="onCancel()">Cancel</button>
  </mat-dialog-actions>
  } @else {
  <mat-dialog-actions align="end">
    <button mat-flat-button (click)="onCancel()">Close</button>
  </mat-dialog-actions>
  }
</div>